import { Long } from '@exl-ng/mulo-core';

export enum EsploroCreatorStatus {
    MANUAL = 'MANUAL',
    AFF_STRONG = 'AFF_STRONG',
    AFF_UNCERTAIN = 'AFF_UNCERTAIN',
    NEW_NONAFF = 'NEW_NONAFF',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    NON_AFF_STRONG = 'NON_AFF_STRONG',
    NON_AFF_UNCERTAIN = 'NON_AFF_UNCERTAIN',
    MATCHED_WITH_ID = 'MATCHED_WITH_ID',
    AUTOAFF_VERYSTRONG = 'AUTOAFF_VERYSTRONG',
    AUTOAFF_STRONG = 'AUTOAFF_STRONG',
    AUTOAFF_UNCERTAIN = 'AUTOAFF_UNCERTAIN',
    AUTOAFF_MATCHED_ON_ID = 'AUTOAFF_MATCHED_ON_ID',
    AUTOAFF_MATCHED_WITH_ID = 'AUTOAFF_MATCHED_WITH_ID',
    AFF_VERYSTRONG_AC = 'AFF_VERYSTRONG_AC',
    AFF_STRONG_AC = 'AFF_STRONG_AC',
    AFF_UNCERTAIN_AC = 'AFF_UNCERTAIN_AC',
    NON_AFF_VERYSTRONG_AC = 'NON_AFF_VERYSTRONG_AC',
    NON_AFF_STRONG_AC = 'NON_AFF_STRONG_AC',
    NON_AFF_UNCERTAIN_AC = 'NON_AFF_UNCERTAIN_AC',
    AFF_MATCHED_ON_ID_AC = 'AFF_MATCHED_ON_ID_AC',
    NON_AFF_MATCHED_ON_ID_AC = 'NON_AFF_MATCHED_ON_ID_AC',
    AFF_MATCHED_ON_ID = 'AFF_MATCHED_ON_ID',
    NON_AFF_MATCHED_ON_ID = 'NON_AFF_MATCHED_ON_ID',
    ADDED_BY_SYSTEM = 'ADDED_BY_SYSTEM',
}

export interface EsploroAuthor {
    familyName: string;
    givenName: string;
    middleName?: string;
    suffix?: string;
    usageStatistics?: boolean;
    order?: string;
    fullName: string;
    identifierOrcid?: string;
    identifierIsni?: string;
    identifierResearcherid: string;
    identifierScopus?: string;
    identifierArxiv?: string;
    identifierEra?: string;
    identifierOrcidUri?: string;
    identifierIsniUri?: string;
    identifierResearcheridUri?: string;
    identifierScopusUri?: string;
    identifierArxivUri?: string;
    identifierPubmed?: string;
    identifierLcnaf?: string;
    identifierWikidata?: string;
    identifierViaf?: string;
    identifierEraUri?: string;
    primaryId?: string;
    barcode?: string;
    additional?: string;
    additionalIdentifiers?: { [key: string]: string };
    affiliation: string[];
    affiliationName?: string[];
    emails?: string[];
    organization?: string;
    role?: string;
    isDisplayInPublicProfile?: boolean;
    status: EsploroCreatorStatus;
    finalGrade?: number;
    almaId?: Long;
    additionalAffiliations?: any[];
    mappedAffiliationErodCode?: string;
    mappedAffiliationErodCodes?: string[];
    affiliationWithDesc?: { [key: string]: string }[];
}
